import Vue from "vue";

export default class SystemContextService {
  constructor() {}

  setSystem(json) {
    Vue.prototype.$localStorageService.setItem("system", json);
  }
  getSystem() {
    return JSON.parse(Vue.prototype.$localStorageService.getItem("system"));
  }
}
